import request from "../plugins/axios";

export function tenantLogin(data) {
    return request({
        url: '/tenant_main_user/Login',
        method: 'POST',
        data
    })
}
export function tenantGetUserList(data) {
    return request({
        url: '/tenant_main_user/TenantList',
        method: 'POST',
        data
    })
}

export function tenantOverview(data) {
    return request({
        url: '/tenant_main_user/TenantOverview',
        method: 'POST',
        data
    })
}
export function tenantAnalysisOverview(data) {
    return request({
        url: '/tenant_main_user/TenantAnalysisOverview',
        method: 'POST',
        data
    })
}
export function tenantLogout(data) {
    return request({
        url: '/tenant_main_user/Logout',
        method: 'POST',
        data
    })
}